<button mat-raised-button color="primary"
        matTooltip="{{tooltip}}"
        (click)="launchDownloader()"
><mat-icon>file_upload</mat-icon>
  Téléversement du {{type}}
</button>

